import { render, staticRenderFns } from "./PoliticasLaason.vue?vue&type=template&id=2353fd1e&scoped=true&"
import script from "./PoliticasLaason.vue?vue&type=script&lang=js&"
export * from "./PoliticasLaason.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasLaason.vue?vue&type=style&index=0&id=2353fd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353fd1e",
  null
  
)

export default component.exports